import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import '../assets/css/panel.scss';
import html2canvas from 'html2canvas';
import Autosuggest from 'react-autosuggest';

import ScrollLock, { TouchScrollable } from 'react-scrolllock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobeEurope,faSignOutAlt, faClock, faTachometer, faChevronLeft, faSearch,faUserTie,faTasks, faAnalytics, faCog,faReceipt,faPennant,faUsers,faUserHeadset,faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { StickyContainer, Sticky } from 'react-sticky';
//import img from 'react-image-webp';

import TipBox from '../components/tipBox';

// SECTIONS
import DashBoard from "./dashboard";
import Projects, {ProjectsMenu} from "./projects";
import Analytics from "./analytics";
import Activity from "./activity";
import Customers, {CustomersMenu} from "./customers";
import Users from "./users";
import Settings from "./settings";

import Topics from "./topics";
import Posts from "./posts";
import Pdf from "./pdf";

// PANELS
import PanelForm from '../components/sidePanel/offerForm';
import PanelOrder from '../components/sidePanel/orderForm';
import PanelWorkOrder from '../components/sidePanel/workOrderForm';
import PanelProject from '../components/sidePanel/project';
import PanelRevisePapers from '../components/sidePanel/revisePapers';
import PanelPackingList from '../components/sidePanel/packingList';

// POPUP
import PopUpOffer from '../components/popUp/offer';
import PopupAssignToUser from '../components/popUp/assignToUser';
import PopupCreateCustomer from '../components/popUp/createCustomer';
import PopupNotes from '../components/popUp/notes';

import Actions from '../helpers/actions';
import {useIntl, FormattedMessage, FormattedRelativeTime} from "react-intl";
import Offer from "../components/popUp/offer";
import Functions from "../helpers/functions";


const Breadcrumbs = (data) => {
    var titles = data.titles;
    const intl = useIntl();
    return(
        <Route path="*" render={props => {
            var parts = new Array();
            let partsTMP = new Array();
            if(props.location.pathname == "/"){
                partsTMP = new Array("","dashboard","");
            } else {
                partsTMP = props.location.pathname.split("/");
            }


            partsTMP.forEach((part,i)=>{
                var url = ['', ...partsTMP.slice(0, i + 1)];
                var title = (url[url.length - 1] != ""?intl.formatMessage({ id: 'titles.'+url[url.length - 1], defaultMessage:titles[i -1]}):"");

                parts.push({url:url,title:title});
            });
            parts = parts.slice(1, parts.length-1);
            const back = parts[parts.length-2];

            return <div className={"row"}>
                        <h1 className={"columns shrink"}>
                            {(parts.length > 1?<Link className="back" to={back.url.join("/").replace(/^\/|\/$/g, '')+"/"}><FontAwesomeIcon icon={faChevronLeft} size="x1"/></Link>:"")}
                            {parts.map(crumb)}
                        </h1>
                        {switchPage(parts)}
                    </div>
        }} />
    )
}
const switchPage = (parts) => {
    if(parts[0]["url"][2] == "dashboard" || parts[0]["url"][2] == "analytics"){
        return (
            <div className={"columns shrink"}>
                <div id={"switch"}>
                    <div className="selected">
                        <div className={"row"}>
                            <div className={"columns"}><span className={"slashes"}>-</span><span>{(Actions.getView() == 1?"Admin":"Quality")} View</span></div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon icon={faChevronDown} size="x1"/>
                            </div>
                        </div>
                    </div>
                    <ul className={"dropDown"}>
                        <li onClick={()=>{
                            Actions.setView(1);
                        }}>
                            Admin View
                        </li>
                        <li onClick={()=>{
                            Actions.setView(2);
                        }}>Quality View</li>
                    </ul>
                </div>
            </div>
        );
    } else {
        return null;
    }
}
const crumb = (part, partIndex, parts) => {
    var url = "";
    part.url.forEach((step,i)=>{
        if(i > 0){
            url += step+"/";
        }
    });
    return (<Link className={"link"+(parts.length > partIndex + 1?"":" last")} key={url} to={url}>{part.title}{parts.length > partIndex + 1?" / ":""}</Link>);
}

// AUTO SUGGESTION

    const languages = [
        {
            name: 'DY1335-123355',
            year: 1972
        },
        {
            name: 'DY661-12333193',
            year: 2012
        },
        {
            name: 'DY6772-2343234',
            year: 2012
        },
    ];
    // Teach Autosuggest how to calculate suggestions for any given input value.
    const getSuggestions = value => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0 ? [] : languages.filter(lang =>
            lang.name.toLowerCase().slice(0, inputLength) === inputValue
        );
    };

export default class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sidePanel:false,
            popUp:false,
            lockScroll:false,
            prevPath:"",
            titles:["","","","",""],
            searchValue: '',
            suggestions: [],
            data:{},
            popUpType:"offer",
            sidePanelType:"offer",
            view:Actions.getView(),
            notifications:[]
        };
        Actions.register("closeSidePanel",this.closeSidePanel.bind(this));
        Actions.register("viewSwitch",this.viewSwitch.bind(this));
        Actions.register("openProject",this.openProjectPanel.bind(this));
        Actions.register("notification",this.getNotifications.bind(this));
        Actions.register("openPopUp",this.openPopUp.bind(this));
        console.log(Actions.getPermissions());
    }

    componentDidMount(){
        this.getNewNotifications();
        this.getNotifications();
    }
    async getNotifications(){
        try {
            var url = Functions.generateURI(
                "/user/notifications/get/all",
                {
                    method:"POST"
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();
            if(response.data.length > 0){
                this.setState({notifications:response.data});
            }
        } catch(error) {

        }
    }
    async getNewNotifications(){
        try {

            var url = Functions.generateURI(
                "/user/notifications/get/new",
                {
                    method:"POST"
                }
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();
            if(response.data.length > 0){
                var message = "";
                this.state.notifications.forEach((notification)=>{
                    switch(notification.notification.notificationType){
                        case "OfferCreated":
                            message = "New offer created";
                            break;
                    }
                });
                Actions.emit("notification",{message:message});
                this.getNotifications();
            }
            setTimeout(()=>{
                this.getNewNotifications()
            },5000);
        } catch(error) {

        }
    }
    closeSidePanel(){
        this.setState({sidePanel:false,lockScroll:false,data:{}});
    }
    viewSwitch(view){
        this.setState({view:view});
    }
    openProjectPanel(data){
        this.setState({sidePanel:true,lockScroll:true,sidePanelType:"project",data:data});
    }

    onChange = (event, { newValue }) => {
        this.setState({
            searchValue: newValue
        });
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value)
        });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };
    setTitle(title,target){
        var titles = this.state.titles;
        titles[(target - 1)] = title;
        this.setState({titles:titles});
    }
    openSidePanel(target,id,vars){
        vars = (typeof vars == "undefined"?{}:vars);
        this.setState({sidePanel:false,lockScroll:true,data:vars},()=>{
            setTimeout(()=>{
                this.setState({sidePanel:true})
            },500);
        });
    }
    openPopUp(target,id,vars){
        if(typeof target == "object"){
            vars = target.data;
            target = target.target;
        }
        vars = (typeof vars == "undefined"?{}:vars);
        this.setState({popUp:false,lockScroll:true,data:vars},()=>{
            setTimeout(()=>{
                this.setState({popUp:true,popUpType:target})
            },500);
        });
    }
    renderPopUpContainer(){
        if(this.state.popUp){
            switch(this.state.popUpType){
                case "notes":
                    return(
                        <PopupNotes data={this.state.data} closePopUp={()=>{
                            this.setState({popUp:false,lockScroll:false});
                        }}/>
                    );
                    break;
                case "offer":
                    return(
                        <PopUpOffer data={this.state.data} closePopUp={()=>{
                            this.setState({popUp:false,lockScroll:false});
                        }} openOfferForm={(vars)=>{
                            this.setState({sidePanel:true,lockScroll:true,data:vars});
                        }}/>
                    );
                    break;
                case "assignToUser":
                    return(
                        <PopupAssignToUser data={this.state.data} closePopUp={()=>{
                            this.setState({popUp:false,lockScroll:false});
                        }} openOfferForm={(vars)=>{
                            this.setState({sidePanel:true,lockScroll:true,data:vars});
                        }}/>
                    );
                    break;
                case "createCustomer":
                    return(
                        <PopupCreateCustomer data={this.state.data}
                                             closePopUp={()=>{
                            this.setState({popUp:false,lockScroll:false});
                        }}/>
                    );
                    break;
            }
        }
    }
    renderSidePanel(){
        if(this.state.sidePanel){
            switch(this.state.sidePanelType){
                case "offer":
                    return(<PanelForm data={this.state.data}/>);
                    break;
                case "order":
                    return(<PanelOrder data={this.state.data}/>);
                    break;
                case "workOrder":
                    return(<PanelWorkOrder data={this.state.data}/>);
                    break;
                case "project":
                    return(<PanelProject data={this.state.data}/>);
                    break;
                case "revisePapers":
                    return(<PanelRevisePapers data={this.state.data}/>);
                    break;
                case "revisePackingList":
                    return(<PanelPackingList data={this.state.data}/>);
                    break;
            }
        }
    }
    renderNotifications(){
        return this.state.notifications.map((notification)=>{
            switch(notification.notification.notificationType){
                case "OfferCreated":
                    return(
                        <li className="transition">
                            <Link to={"/projects/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                <div className="row">
                                    <div className="columns detail">
                                        <p>
                                            Created new offer
                                        </p>
                                        <small className="date">
                                            <FontAwesomeIcon  icon={faClock} size="lg"/>
                                            <span><FormattedRelativeTime value={(notification.notification.creationDate - new Date().getTime())} numeric="auto" updateIntervalInSeconds={10} /></span>
                                        </small>
                                    </div>
                                </div>
                            </Link>
                        </li>
                    );
                    break;
            }
        });
    }
    renderAutoSuggestSearch(){
        if(false){
            return(
                <Autosuggest
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={(suggestion)=>{return suggestion.name}}
                    renderSuggestion={(suggestion)=>{
                        return(
                            <div onClick={()=>{
                                Actions.emit("openProject",{test:true});
                            }}>
                                {suggestion.name}
                            </div>
                        );
                    }}
                    inputProps={{
                        placeholder: 'Kullanıcı veya proje ara',
                        value:this.state.searchValue,
                        onChange: this.onChange
                    }}
                />
            );
        }
    }
    render(){
        return (
            <div id={"panel"}>
                <div className={"header"}>
                    <div className={"row"}>
                        <div className={"columns shrink"}>
                            <img src={"/assets/images/logo.png"} className={"logo"} />
                        </div>
                        <div className="columns">
                            <div id={"searchBox"}>
                                <FontAwesomeIcon icon={faSearch} size="x1"/>
                                {this.renderAutoSuggestSearch()}
                            </div>
                        </div>
                        <div className={"columns shrink"}>
                            <div id={"profile"}>
                                <div className={"row collapse"}>
                                    <div className={"columns shrink"}>
                                        <div className={"row collapse"}>
                                            <div className={"columns"}>
                                                <div className="fullName">{Actions.getUser().data.fullName}</div>
                                                <div className="title">Doğan Yıldız</div>
                                            </div>
                                            <div className={"columns shrink"}>
                                                <img className={"profileImg"} src={"http://app.botonom.com/assets/img/users/0.jpg"}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"columns shrink"}>
                                        <div className={"notifications"}>
                                            <FontAwesomeIcon  icon={faGlobeEurope} size="lg"/>
                                            <div className={"transition dropDown ds"}>
                                                <div className={"arrowBox"}>
                                                    <div className={"list"}>
                                                        <ul>
                                                            {this.renderNotifications()}
                                                        </ul>
                                                    </div>
                                                    <a href="#a" className="showAll transition">Show all notifications</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"columns shrink"}>
                                        <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                                            return(
                                                <a className={"logOut"} onClick={()=>{
                                                    Actions.logout();
                                                    return false;
                                                }}>
                                                    <FontAwesomeIcon  icon={faSignOutAlt} size="2x"/>
                                                </a>
                                            )
                                        }} content={()=>{
                                            return(
                                                <p className={"tipBoxWrapper small"}>
                                                    <FormattedMessage
                                                        id="panel.logoutTitle"
                                                    />
                                                </p>
                                            )
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <StickyContainer>
                    <div className={"row"}>
                        <div id="sideMenu" className="columns shrink">
                            <Sticky>

                                {({
                                      style,

                                      // the following are also available but unused in this example
                                      isSticky,
                                      wasSticky,
                                      distanceFromTop,
                                      distanceFromBottom,
                                      calculatedHeight
                                  }) => (
                                    <nav style={style}>
                                        <ul>
                                            <li className={(this.props.location.pathname.split("/")[1] == ""?"active":"")}>
                                                <TipBox isOpen={this.state.toolTipOpen} attachment={"middle left"} element={()=>{
                                                    return(
                                                        <Link to={"/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                                            <FontAwesomeIcon  icon={faTachometer} size="lg"/>
                                                        </Link>
                                                    )
                                                }} content={()=>{
                                                    return(
                                                        <p className={"tipBoxWrapper small"}>
                                                            <FormattedMessage
                                                                id="panel.dashBoardTitle"
                                                            />
                                                        </p>
                                                    )
                                                }}/>
                                            </li>
                                            <li style={{display:(Actions.hasAccess(2)?"block":"none")}} className={(this.props.location.pathname.split("/")[1] == "projects"?"active":"")}>
                                                <TipBox isOpen={this.state.toolTipOpen} attachment={"middle left"} element={()=>{
                                                    return(
                                                        <Link to={"/projects/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                                            <FontAwesomeIcon  icon={faTasks} size="lg"/>
                                                        </Link>
                                                    )
                                                }} content={()=>{
                                                    return(
                                                        <p className={"tipBoxWrapper small"}>
                                                            <FormattedMessage
                                                                id="panel.projectsTitle"
                                                            />
                                                        </p>
                                                    )
                                                }}/>
                                            </li>
                                            <li style={{display:(Actions.hasAccess(100)?"block":"none")}} className={(this.props.location.pathname.split("/")[1] == "analytics"?"active":"")}>
                                                <TipBox isOpen={this.state.toolTipOpen} attachment={"middle left"} element={()=>{
                                                    return(
                                                        <Link to={"/analytics/summary/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                                            <FontAwesomeIcon  icon={faAnalytics} size="lg"/>
                                                        </Link>
                                                    )
                                                }} content={()=>{
                                                    return(
                                                        <p className={"tipBoxWrapper small"}>
                                                            <FormattedMessage
                                                                id="panel.analyticsTitle"
                                                            />
                                                        </p>
                                                    )
                                                }}/>
                                            </li>
                                            <li style={{display:(Actions.hasAccess(100)?"block":"none")}} className={(this.props.location.pathname.split("/")[1] == "activity"?"active":"")}>
                                                <TipBox isOpen={this.state.toolTipOpen} attachment={"middle left"} element={()=>{
                                                    return(
                                                        <Link to={"/activity/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                                            <FontAwesomeIcon  icon={faGlobeEurope} size="lg"/>
                                                        </Link>
                                                    )
                                                }} content={()=>{
                                                    return(
                                                        <p className={"tipBoxWrapper small"}>
                                                            <FormattedMessage
                                                                id="panel.activityTitle"
                                                            />
                                                        </p>
                                                    )
                                                }}/>
                                            </li>
                                            <li style={{display:(Actions.hasAccess(7)?"block":"none")}} className={(this.props.location.pathname.split("/")[1] == "customers"?"active":"")}>
                                                <TipBox isOpen={this.state.toolTipOpen} attachment={"middle left"} element={()=>{
                                                    return(
                                                        <Link to={"/customers/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                                            <FontAwesomeIcon  icon={faUsers} size="lg"/>
                                                        </Link>
                                                    )
                                                }} content={()=>{
                                                    return(
                                                        <p className={"tipBoxWrapper small"}>
                                                            <FormattedMessage
                                                                id="panel.customersTitle"
                                                            />
                                                        </p>
                                                    )
                                                }}/>
                                            </li>
                                            <li style={{display:(Actions.hasAccess(100)?"block":"none")}} className={(this.props.location.pathname.split("/")[1] == "users"?"active":"")}>
                                                <TipBox isOpen={this.state.toolTipOpen} attachment={"middle left"} element={()=>{
                                                    return(
                                                        <Link to={"/users/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                                            <FontAwesomeIcon  icon={faUsers} size="lg"/>
                                                        </Link>
                                                    )
                                                }} content={()=>{
                                                    return(
                                                        <p className={"tipBoxWrapper small"}>
                                                            <FormattedMessage
                                                                id="panel.usersTitle"
                                                            />
                                                        </p>
                                                    )
                                                }}/>
                                            </li>
                                            <li style={{display:(Actions.hasAccess(100)?"block":"none")}} className={(this.props.location.pathname.split("/")[1] == "settings"?"active":"")}>
                                                <TipBox isOpen={this.state.toolTipOpen} attachment={"middle left"} element={()=>{
                                                    return(
                                                        <Link to={"/settings/general/"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}>
                                                            <FontAwesomeIcon  icon={faCog} size="lg"/>
                                                        </Link>
                                                    )
                                                }} content={()=>{
                                                    return(
                                                        <p className={"tipBoxWrapper small"}>
                                                            <FormattedMessage
                                                                id="panel.settingsTitle"
                                                            />
                                                        </p>
                                                    )
                                                }}/>
                                            </li>
                                        </ul>
                                    </nav>
                                )}
                            </Sticky>
                        </div>
                        <div id={"panelContent"} className="columns">
                            <div>
                                <div id={"sidePanel"} className={"row collapse align-right transition"+(this.state.sidePanel?" open":"")}>
                                    <div className={"outTrigger"} onClick={()=>{this.setState({sidePanel:false,popUp:false,lockScroll:false})}}></div>
                                    <Sticky topOffset={13}>
                                        {({
                                              style,

                                              // the following are also available but unused in this example
                                              isSticky,
                                              wasSticky,
                                              distanceFromTop,
                                              distanceFromBottom,
                                              calculatedHeight
                                          }) => (
                                            <div style={style} className={"columns shrink noPadding transition"}>
                                                <div style={{height:(window.innerHeight - 10)+"px"}}>
                                                    {this.renderSidePanel()}
                                                </div>
                                            </div>
                                        )}
                                    </Sticky>
                                </div>
                                <div id={"popUp"} className={"row collapse align-right transition"+(this.state.popUp?" open":"")}>
                                    <div style={{height:(window.innerHeight - 10)+"px"}} >
                                        {this.renderPopUpContainer()}
                                        <div className={"outTrigger"} onClick={()=>{
                                            // eslint-disable-next-line no-restricted-globals
                                            var r = confirm("Are you sure to close ?");
                                            if (r == true) {
                                                this.setState({sidePanel:false,popUp:false,lockScroll:false})}
                                            }
                                        }></div>
                                    </div>
                                </div>
                                <Sticky topOffset={13}>
                                    {({
                                          style,

                                          // the following are also available but unused in this example
                                          isSticky,
                                          wasSticky,
                                          distanceFromTop,
                                          distanceFromBottom,
                                          calculatedHeight
                                      }) => (
                                        <div style={style} className={"header"+(isSticky?" sticked":"")}>
                                            <div className={"row collapse transition"}>
                                                <Breadcrumbs setTitle={this.setTitle.bind(this)} titles={this.state.titles}/>
                                                <div className={"columns"}>
                                                    <div className={"row align-right"}>
                                                        <div className={"columns shrink"}>
                                                            <Switch>
                                                                <Route path="/projects" render={(props) => <ProjectsMenu {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)}  openOfferForm={(vars)=>{
                                                                    this.setState({sidePanel:true,lockScroll:true,data:vars});
                                                                }} url={this.props.location.pathname.split("/")} /> }/>
                                                                <Route path="/customers" render={(props) => <CustomersMenu {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                                            </Switch>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Sticky>
                                <div className={"content"}>
                                    <div className={"columns"}>
                                        <Switch>
                                            <Route path="/pdf" render={(props) => <Pdf {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/topics" render={(props) => <Topics {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/posts" render={(props) => <Posts {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/projects" render={(props) => <Projects {...props} setTitle={this.setTitle.bind(this)} openOrderForm={(vars)=>{
                                                this.setState({sidePanel:true,lockScroll:true,sidePanelType:"order",data:vars});
                                            }} openOfferForm={(vars)=>{
                                                this.setState({sidePanel:true,lockScroll:true,data:vars});
                                            }} revisePackingList={(vars)=>{
                                                vars.isRevise = true;
                                                this.setState({sidePanel:true,lockScroll:true,sidePanelType:"revisePackingList",data:vars});
                                            }}
                                            revisePapers={(vars)=>{
                                                vars.isRevise = true;
                                                this.setState({sidePanel:true,lockScroll:true,sidePanelType:"revisePapers",data:vars});
                                            }} reviseOffer={(vars)=>{
                                                vars.isRevise = true;
                                                this.setState({sidePanel:true,lockScroll:true,sidePanelType:"offer",data:vars});
                                            }} openWorkOrderForm={(vars)=>{
                                                this.setState({sidePanel:true,lockScroll:true,sidePanelType:"workOrder",data:vars});
                                            }} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/analytics" render={(props) => <Analytics {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/activity" render={(props) => <Activity {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/customers" render={(props) => <Customers {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} openEditPopup={(vars)=>{
                                                this.setState({popUp:true,popUpType:"createCustomer",data:vars})
                                            }} assignToUserPopUp={(vars)=>{
                                                this.setState({popUp:true,popUpType:"assignToUser",data:vars})
                                            }} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/users" render={(props) => <Users {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/settings" render={(props) => <Settings {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                            <Route path="/" render={(props) => <DashBoard {...props} setTitle={this.setTitle.bind(this)} openSidePanel={this.openSidePanel.bind(this)} openPopUp={this.openPopUp.bind(this)} url={this.props.location.pathname.split("/")} /> }/>
                                        </Switch>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </StickyContainer>
                <div className={"footer"}>
                    <div className="info row">
                        <div className="columns">
                            <div className={"content"}>
                                <div className="legal">
                                    <div>Bu yazılım Doğan Yıldız trailerlerinin üretim süreçlerini dijital olarak yönetebilmesi için tasarlanmıştır.</div>
                                    <div>
                                        Şu an kullandığınız ekranda bir sorun olduğunu düşünüyorsanız lütfen <a onClick={()=>{
                                        html2canvas(document.querySelector("#root")).then(canvas => {
                                            // Get base64URL
                                            var base64URL = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
                                            console.log(base64URL);

                                        });
                                    }}>buraya</a> tıklayarak raporlayın.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="columns shrink">
                            <div className={"content"}>
                                <div>
                                    <span className="copyRight">
                                        ©{new Date().getFullYear()}&nbsp;-&nbsp;
                                        <FormattedMessage
                                            id="app.copyrightText"
                                        />
                                    </span>
                                </div>
                                <div>
                                    <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                                        return(
                                            <a href="http://www.omg.works" target="_blank" className={"dev"}>
                                                <img src={"/assets/images/omg_logo.svg"} alt="Design &amp; Development"/>
                                            </a>
                                        )
                                    }} content={()=>{
                                        return(
                                            <p className={"tipBoxWrapper small"}>
                                                <FormattedMessage
                                                    id="app.developedByText"
                                                />
                                            </p>
                                        )
                                    }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollLock isActive={this.state.lockScroll} />
            </div>
        );
    }
}
